import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({
  title,
  className = '',
  showToolTip = true,
  containerClassName = '',
  onClick,
  iconComponent,
  ...rest
}) => {
  const icon = iconComponent ? (
    iconComponent
  ) : (
    <i className={`${className} ${onClick ? 'clickable' : ''}`} title={title} onClick={onClick} />
  );

  if (!showToolTip) {
    return React.cloneElement(icon, { ...rest });
  }

  return (
    <div className={`highed-template-tooltip ${containerClassName}`} {...rest}>
      {icon}
      <span className="highed-tooltip-text">{title}</span>
    </div>
  );
};

Icon.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  iconComponent: PropTypes.any,
  title: PropTypes.string,
  showToolTip: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Icon;
